import * as React from 'react';

import styles from './Magazine.css';
import { TMagazineModel } from '../../types';
import { HorizontalScroll } from '../HorizontalScroll';
import { MagazineItem } from '../MagazineItem/MagazineItem';

export interface IMagazineProps {
  magazineList: TMagazineModel[];
}

export function Magazine({ magazineList }: IMagazineProps) {
  if (magazineList.length < 1) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <HorizontalScroll size={264} containerStyle={styles['scroll']} arrowStyles={styles['arrow']} loop>
        {magazineList.map(magazine => (
          <MagazineItem key={magazine.url} {...magazine} />
        ))}
      </HorizontalScroll>
    </div>
  );
}
